import { gsap } from "gsap";
import {wpPaths} from "../../utils/Utils.js";

const Anim01 = () => {

	// GIF ANIMATION
	const animAssetsBasePath = `${wpPaths.images}/animation/anim01/`;
	const svgContainer = document.getElementById('anim01');

	fetch(animAssetsBasePath + 'design.svg')
		.then(response => response.text())
		.then(data => {
			svgContainer.innerHTML = data;

			/* ********************************
				SET BASICS
			******************************** */
			/*
			const boxLogos = [
				'icons-animation-arla',
				'icons-animation-antibulli',
				'icons-animation-dsb',
				'icons-animation-gronforskel',
				'icons-animation-dot',
				'icons-animation-droetker',
				'icons-animation-eboks',
				'icons-animation-lego',
				'icons-animation-nilfisk',
				'icons-animation-q8',
				'icons-animation-solgryn'
			];
			shuffle(boxLogos);
			const boxLogosLength = boxLogos.length;
			*/
			const timeScaleVar = 0.85;

			//const box = document.getElementById('box');
			const codeMask = document.getElementById('codeMask');
			const computerMask = document.getElementById('computerMask');
			//const gear01 = document.getElementById('gear01');
			//const gear02 = document.getElementById('gear02');
			//const gear03 = document.getElementById('gear03');
			const mortenHead = document.getElementById('mortenHead');
			const mortenLarm = document.getElementById('mortenLarm');
			const mortenRarm = document.getElementById('mortenRarm');
			const suneRarm = document.getElementById('suneRarm');
			const suneLarm = document.getElementById('suneLarm');
			const floppy01 = document.getElementById('floppy01');
			const floppy02 = document.getElementById('floppy02');
			//let curLogo = 0;

			/* ********************************
				SWITCH IMAGE
			******************************** */
			/*
			const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
			img.setAttribute('height', '50');
			img.setAttribute('width', '64');
			img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `${animAssetsBasePath}${boxLogos[curLogo]}.svg`);
			img.setAttribute('x', '511px');
			img.setAttribute('id', 'boxLogo');
			img.setAttribute('y', '249px');
			img.setAttribute('visibility', 'visible');
			box.appendChild(img);
			const boxLogo = document.getElementById('boxLogo');

			function switchImage() {
				curLogo++;
				if (curLogo >= boxLogosLength) {
					curLogo = 0;
				}
				boxLogo.setAttribute('href', `${animAssetsBasePath}${boxLogos[curLogo]}.svg`);
			}

			function shuffle(a) {
				let j, x, i;
				for (i = a.length - 1; i > 0; i--) {
					j = Math.floor(Math.random() * (i + 1));
					x = a[i];
					a[i] = a[j];
					a[j] = x;
				}
			}
			*/

			/* ********************************
				SCREEN ANI
			******************************** */
			const screenAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			screenAni
				.set(codeMask, { transformOrigin: "50% 100%", scaleY: 1 })
				.to(codeMask, { duration: 0.25, scaleY: 0 })
				.set({}, {}, "+=0.25")
				.to(codeMask, { duration: 0.25, scaleY: 1 })
				.set({}, {}, "+=0.75");

			screenAni.timeScale(timeScaleVar);

			/* ********************************
				BOX ANI
			******************************** */
			/*
			const boxAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			boxAni
				.set(box, { transformOrigin: "50% 100%" })
				.to(box, { duration: 0.5, x: 190, rotation: 0, ease: "power4.in" })
				.set({}, {}, "+=0.25")
				.to(box, { duration: 0.5, x: 0, rotation: 0, ease: "power4.out" })
				.set({}, {}, "+=0.75")
				.add(switchImage, 0.75);

			boxAni.timeScale(timeScaleVar);
			*/

			/* ********************************
				GEAR ANI
			******************************** */
			/*
			const gearAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			gearAni
				.to(gear01, { duration: 0.5, rotation: 360, ease: "power2.in", transformOrigin: "50% 50%" })
				.to(gear02, { duration: 0.5, rotation: 360, ease: "power2.in", transformOrigin: "50% 50%" }, '-=0.5')
				.to(gear03, { duration: 0.5, rotation: 360, ease: "power2.in", transformOrigin: "50% 50%" }, '-=0.5')
				.to(gear01, { duration: 0.5, rotation: 0, ease: "power2.out", transformOrigin: "50% 50%" })
				.to(gear02, { duration: 0.5, rotation: 0, ease: "power2.out", transformOrigin: "50% 50%" }, '-=0.5')
				.to(gear03, { duration: 0.5, rotation: 0, ease: "power2.out", transformOrigin: "50% 50%" }, '-=0.5');

			gearAni.timeScale(timeScaleVar);
			*/

			/* ********************************
				COMPUTER MASK ANI
			******************************** */
			const computerMaskAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			computerMaskAni
				.set(computerMask, { visibility: "visible" })
				.set({}, {}, "+=1.2")
				//.set(computerMask, { visibility: "hidden" })
				.set({}, {}, "+=0.8");

			computerMaskAni.timeScale(timeScaleVar);

			/* ********************************
				MORTEN HEAD ANI
			******************************** */
			const mortenHeadAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			mortenHeadAni
				.to(mortenHead, { duration: 0.25, rotation: 5, ease: "power1.inOut", transformOrigin: "60 190" })
				.to(mortenHead, { duration: 0.25, rotation: 0, ease: "power1.inOut", transformOrigin: "60 190" })
				.set({}, {}, "+=1.5");

			mortenHeadAni.timeScale(timeScaleVar);

			/* ********************************
				MORTEN R ARM ANI
			******************************** */
			const mortenRarmAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			mortenRarmAni
				.set(mortenRarm, { transformOrigin: "6% 91%" })
				.to(mortenRarm, { duration: 1, rotation: 120, ease: "power4.inOut" })
				.to(mortenRarm, { duration: 1, rotation: 0, ease: "power4.inOut" });

			mortenRarmAni.timeScale(timeScaleVar);

			/* ********************************
				MORTEN L ARM ANI
			******************************** */
			const mortenLarmAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			mortenLarmAni
				.set(mortenLarm, { rotation: 60 })
				.to(mortenLarm, { duration: 0.5, rotation: 0, ease: "power1.inOut" })
				.to(mortenLarm, { duration: 0.6, rotation: 0, ease: "power1.inOut" })
				.to(mortenLarm, { duration: .5, rotation: 60, ease: "power1.inOut" })
				.set({}, {}, "+=.9");

			mortenLarmAni.timeScale(timeScaleVar);

			/* ********************************
				FLOPPY01 ANI
			******************************** */
			const floppy01Ani = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			floppy01Ani
				.set(floppy01, { svgOrigin: "69 214" })
				.set(floppy01, { rotation: 60 })
				.to(floppy01, { duration: 0.5, rotation: 0, ease: "power1.inOut" })
				.to(floppy01, { duration: 0.1, rotation: 0, x: 35, ease: "power4.in" })
				//.set({}, {}, "+=0.5")
				//.to(floppy01, { rotation: 60, x: 0 })
				.set({}, {}, "+=0.5")
				.set(floppy01, { rotation: 60, x: 0 }, "+=0.5")
				.set({}, {}, "+=0.9");

			floppy01Ani.timeScale(timeScaleVar);

			/* ********************************
				SUNE R ARM ANI
			******************************** */
			const suneRarmAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			suneRarmAni
				.set(suneRarm, { svgOrigin: "386 216" })
				.set(suneRarm, { rotation: -40 })
				.set({}, {}, "+=1")
				.to(suneRarm, { duration: 0.2, rotation: 0, ease: "power4.in" })
				.to(suneRarm, { duration: 0.3, rotation: 90, ease: "none" })
				.to(suneRarm, { duration: 0.5, rotation: -40, ease: "power4.inOut" });

			suneRarmAni.timeScale(timeScaleVar);

			/* ********************************
				SUNE L ARM ANI
			******************************** */
			const suneLarmAni = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			suneLarmAni
				.set(suneLarm, { svgOrigin: "414 216" })
				.set(suneLarm, { rotation: 0 })
				.to(suneLarm, { duration: 1, rotation: 110, ease: "power4.inOut" })
				.to(suneLarm, { duration: 1, rotation: 0, ease: "power4.inOut" });

			suneLarmAni.timeScale(timeScaleVar);

			/* ********************************
				FLOPPY02 ANI
			******************************** */
			const floppy02Ani = gsap.timeline({
				onComplete: function() {
					this.restart();
				}
			});

			floppy02Ani
				.set(floppy02, { rotation: 0, x: -35, svgOrigin: "386 216" })
				.set({}, {}, "+=0.9")
				.to(floppy02, { duration: 0.3, x: 0, ease: "back.out" })
				.to(floppy02, { duration: 0.3, rotation: 120, ease: "none" })
				.to(floppy02, { duration: 0.4, rotation: 220, x: 35, y: 10, ease: "none", opacity: 0 })
				.set({}, {}, "+=0.1");

			floppy02Ani.timeScale(timeScaleVar);
		});


}

export default Anim01;